import React, { Component } from 'react'

import PostsContent from './PostsContent'
import Navbar from 'cms/components/Navbar';
import Mainmenu from 'cms/components/Mainmenu';
import Footer from 'cms/components/Footer';
export default class Posts extends Component {

    render() {

        let page = this.props.match.params.page;

        const urlParams = new URLSearchParams(window.location.search);

        return (
            <div className="wrapper">
                <Navbar />
                <Mainmenu />
                <PostsContent urlParams={urlParams} page={page} />
                <Footer />

            </div>


        )
    }
}
